import BaseFormPage from "../../../base/BaseFormPage";
import {
  deleteObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import SuppliersFormPagePresenter from "./SuppliersFormPagePresenter";
import dialog from "../../../components/Modal/dialog.js";
import FullPageLoader from "../../../components/FullPageLoader/index.js";
import SuppliersForm from "./components/SuppliersForm.js/SupplierForm.js";
import PageHeader from "../../../components/PageHeader/index.js";
import { InfiniteScroll } from "../../../nq-component";

class SuppliersFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
    };
    this.presenter = new SuppliersFormPagePresenter(
      this,
      getObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "suppliers";
  }

  getProvinces(region) {
    this.presenter.getAllProvinces(region);
  }

  getClientId() {
    return this.props.params.id;
  }

  onClose() {
    dialog.close();
  }

  discardModal() {
    const message =
      "You have unsaved changes that will be lost if you proceed. Are you sure you want to discard these changes?";
    this.showConfirmDialog(message, "Discard Changes", "DISCARD", "CANCEL")
      .then(() => this.navigateBack())
      .catch(() => {});
  }

  render() {
    const { progress, object } = this.state;
    const user = this.getCurrentUser();
    const schema = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();

    return (
      <>
        <InfiniteScroll className={"overflow-auto"}>
          <div className="p-3 p-xl-4 d-flex flex-column gap-4">
            {/* Header Section */}
            <PageHeader
              breadcrumb={[
                { label: "Home", path: "/" },
                { label: "Suppliers", path: "/suppliers" },
                {
                  label: object?.id ? "Edit Supplier" : "Add Supplier",
                },
              ]}
              title={`Suppliers`}
              backButton
              description={"Enter supllier details"}
            />

            {/* Form Card */}
            <div
              className="bg-white rounded-3 shadow-sm"
              style={{
                padding: "1.5rem",
                border: "1px solid #e9ecef",
              }}
            >
              <SuppliersForm
                object={object}
                onSubmit={this.submitWithPreview.bind(this)}
                onBack={this.navigateBack.bind(this)}
                discardModal={this.discardModal.bind(this)}
                onChange={this.onChange.bind(this)}
                schema={schema}
                schemas={schemas}
                hasActualChanges={this.hasActualChanges.bind(this)}
              />
            </div>
            {progress ? <FullPageLoader /> : ""}
          </div>
        </InfiniteScroll>
        {this.renderPreviewModal()}
      </>
    );
  }
}

export default withRouter(SuppliersFormPage);
